import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehicleNicknamePage } from './vehicle-nickname.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleNicknamePage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleNicknamePageRoutingModule {}
